import { render, staticRenderFns } from "./wizard-payrolls.vue?vue&type=template&id=b7919c10&scoped=true&lang=pug"
import script from "./wizard-payrolls.vue?vue&type=script&lang=ts"
export * from "./wizard-payrolls.vue?vue&type=script&lang=ts"
import style0 from "./wizard-payrolls.vue?vue&type=style&index=0&id=b7919c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7919c10",
  null
  
)

export default component.exports